{
  "controls": {
    "back": "Back",
    "close": "Close",
    "last": "Done",
    "next": "Next",
    "skip": "Skip tour"
  },
  "dashboard": {
    "greeting": {
      "title": "Welcome to your dashboard",
      "body": "This is your home page — a quick overview of opportunities, snipes, and your top realms."
    },
    "kpi": {
      "title": "Live opportunities",
      "body": "How many profitable flips are available right now across all your tools."
    },
    "topOpportunities": {
      "title": "Top opportunities",
      "body": "A live preview of the best flips. Switch tabs to see fast-selling items or top buys."
    },
    "snipeAlerts": {
      "title": "Recent snipes",
      "body": "Snipe alerts triggered during the latest refresh cycle. Click through to configure new alerts."
    },
    "realmStats": {
      "title": "Top realms",
      "body": "Your strongest selling realms ranked by population, auctions, or price ratio."
    },
    "quickActions": {
      "title": "Quick access",
      "body": "Jump straight into any tool from here."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Data status",
      "body": "Shows how fresh the auction data is. The page auto-refreshes when new data arrives."
    },
    "filters": {
      "title": "Filter sidebar",
      "body": "Narrow results by realm, item quality, profit, sale rate, and more. Save your favourite combinations as presets."
    },
    "stats": {
      "title": "Investment summary",
      "body": "Aggregate totals for the visible flips: investment needed, expected revenue, and profit after the auction-house cut."
    },
    "table": {
      "title": "Opportunities",
      "body": "Each row is a flip: buy on one realm, sell on another. Click an item to copy or favourite it."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Move through the result pages and pick how many items to show at once."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Data status",
      "body": "Shows how fresh the housing auction data is and when the next update is expected."
    },
    "filters": {
      "title": "Filter sidebar",
      "body": "Narrow housing flips by realm, profit, sale rate, and buyout cap."
    },
    "stats": {
      "title": "Investment summary",
      "body": "Totals for the visible housing flips so you can size your bankroll before buying."
    },
    "table": {
      "title": "Housing opportunities",
      "body": "Each row is a housing item available cheap on one realm and worth more on another."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Move through pages and adjust how many results to display."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Data status",
      "body": "Shows how fresh the dropship data is and when the next refresh will arrive."
    },
    "filters": {
      "title": "Filter sidebar",
      "body": "Narrow dropship opportunities by realm, quality, expansion, and profitability."
    },
    "stats": {
      "title": "Investment summary",
      "body": "Totals for the visible dropship trades — useful for planning capital and capacity."
    },
    "table": {
      "title": "Dropship opportunities",
      "body": "Each row is an item to buy on one realm and resell on another for a profit margin."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Move through pages of dropship results."
    }
  },
  "inventory": {
    "realms": {
      "title": "Selling realms",
      "body": "Pick the realms you want to analyse your inventory against."
    },
    "csv": {
      "title": "Paste your inventory",
      "body": "Paste a semicolon-delimited CSV of your stock here — the tool will look for profitable cross-realm trades."
    },
    "analyze": {
      "title": "Analyse",
      "body": "Run the cross-realm analysis on the inventory you just pasted."
    },
    "results": {
      "title": "Flip recommendations",
      "body": "Every row is an item from your inventory that is currently worth more on another realm."
    },
    "export": {
      "title": "Export",
      "body": "Download the analysis as CSV for use in a spreadsheet or an addon."
    }
  },
  "stats": {
    "table": {
      "title": "Realm stats",
      "body": "Compare auction prices, listing counts, and trends across all realms in your region."
    }
  },
  "tsm": {
    "filters": {
      "title": "Filters",
      "body": "Pick which items to include based on category, expansion, quality, and profit."
    },
    "table": {
      "title": "Item list",
      "body": "Items that match your filters — copy them straight into a TSM Price Source operation."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Move through pages and pick how many items to show at once."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Alert categories",
      "body": "Switch between item snipes, pet snipes, the WoW token, and item-level rules."
    },
    "add": {
      "title": "Add a new alert",
      "body": "Add an item, pet, or rule to your watch list — you will be notified the moment it drops below your target price."
    },
    "list": {
      "title": "Active alerts",
      "body": "Your configured alerts, with their target prices and assigned webhook channels."
    },
    "import": {
      "title": "Bulk import",
      "body": "Import a whole list at once: click Import to pick a file, or simply paste a copied list anywhere on this page. You will see a preview of what will be imported before anything is saved."
    },
    "inlineEdit": {
      "title": "Edit prices in place",
      "body": "Click any price in the table to edit it right there — Enter saves, Esc cancels. Deleted alerts can be restored with Undo, and you can sort the list by name or price."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Setup video",
      "body": "Watch this short video for the full TSM profile setup walkthrough."
    },
    "min": {
      "title": "Minimum price",
      "body": "Copy this formula into your TSM minimum-price operation."
    },
    "max": {
      "title": "Maximum price",
      "body": "Copy this formula into your TSM maximum-price operation."
    },
    "normal": {
      "title": "Normal price",
      "body": "Copy this formula into your TSM normal-price operation."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Region",
      "body": "Pick US or EU — this drives every realm list across the app."
    },
    "buying": {
      "title": "Buying realms",
      "body": "The realms where you will buy items cheap. Add as many as you can comfortably travel to."
    },
    "selling": {
      "title": "Selling realms",
      "body": "The realms where you will resell items for profit. These appear as targets in every tool."
    },
    "accounts": {
      "title": "WoW accounts",
      "body": "If you play multiple accounts, register them here and assign realms to each."
    },
    "save": {
      "title": "Save your config",
      "body": "Save and the rest of the app will start using these realms immediately."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Filter preview",
      "body": "A live preview of the filter UI you will see across the flipping tools."
    },
    "ranges": {
      "title": "Default ranges",
      "body": "Set the profit, sale rate, and price ranges you want pre-applied on every tool."
    },
    "dashboard": {
      "title": "Dashboard thresholds",
      "body": "Control the min and max buyout for the opportunities shown on your dashboard."
    },
    "matching": {
      "title": "Item matching",
      "body": "Restrict item-stat matching to certain expansions for more accurate cross-realm pricing."
    },
    "save": {
      "title": "Save defaults",
      "body": "Save these settings as your personal defaults across every tool."
    }
  },
  "rowActions": {
    "title": "Row actions menu",
    "body": "The first column now bundles the favorite star, selection checkbox, and snipe-alert bell. Open this menu to select / deselect the current page or everything across all pages, keep only your favorites, or pin favorites, snipe targets, and selected rows to the top of the table. Column settings (drag-to-reorder and show / hide) also live in here."
  },
  "settingsDiscord": {
    "link": {
      "title": "Link your Discord",
      "body": "Connect your Discord account so the bot can send you alerts and notifications."
    },
    "verification": {
      "title": "Verify DMs",
      "body": "Send yourself a 6-digit code to confirm the bot can reach you in DMs."
    },
    "notifications": {
      "title": "Notification settings",
      "body": "Enable DM notifications for region data updates and other events."
    },
    "webhooks": {
      "title": "Webhook categories",
      "body": "Create webhook categories to route snipe alerts to specific Discord channels."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Filter or recalculate",
    "body": "Choose what happens when you change a filter: Filter instantly narrows down the results that are already loaded, Recalculate fetches fresh results from the server."
  }
}
